import { createAsyncThunk } from '@reduxjs/toolkit'
import { getDiceGameBetHistory, diceGamePlaceBet } from 'games/DiceGame/diceGame.service'
import { setDiceBetHistory, setDiceLossCount, setDiceWinsCount, setDiceProfit, setDiceWagered } from 'games/DiceGame/slice-thunk/diceGame.slice'
import {
  setDiceStrategyResultArray,
  setLoseStreakCount,
  setStrategyBetCount,
  setStrategyLoseCount,
  setStrategyWinCount,
  setWinStreakCount
} from 'games/DiceGame/slice-thunk/diceStrategy.slice'
import { BET_RESULT } from 'constants/index'
import { openErrorToaster } from 'helpers/toaster.helpers'
import { generateClientSeed } from 'helpers/common.helpers'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { appendCreditWalletWaitQueue } from 'redux-store/redux/slices/auth.slice'

export const getDiceGameBetRecord = createAsyncThunk(
  'diceGame/get-bet-history', async ({ limit, page }, thunkApi) => {
    try {
      const res = await getDiceGameBetHistory({ limit, page })
      return res
    } catch (error) {
      openErrorToaster(error[0].description)
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const diceGamePlacedBet = createAsyncThunk(
  'diceGame/place-bet', async ({ payload, isDemoGame, handleCancelAutoBet, setBetLock }, thunkApi) => {
    try {
      const res = await diceGamePlaceBet({ data: payload, isDemoGame })
      const { diceBetHistory } = thunkApi?.getState()?.diceGame
      const { isStrategyMode, strategyResultArray } = thunkApi?.getState()?.diceStrategy

      if (res?.nextServerSeedHash) {
        const newClientSeed = generateClientSeed()
        thunkApi.dispatch(setNewClientSeed(newClientSeed))
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }

      let newBetHistory = {}
      let rows = [{ ...res }]
      if (diceBetHistory) {
        rows = [...rows, ...diceBetHistory?.rows]
      }
      newBetHistory = { count: diceBetHistory?.count ? diceBetHistory?.count + 1 : 1, rows }
      thunkApi.dispatch(setDiceBetHistory(newBetHistory))

      // Dispatch wallet update event with the new wallet balance
      if (res?.wallet) {
        thunkApi.dispatch(appendCreditWalletWaitQueue(res.wallet))
      }

      if (res?.result) {
        thunkApi.dispatch(setDiceStrategyResultArray([...strategyResultArray, res?.result]))
      }
      if (isStrategyMode) {
        if (res?.result === BET_RESULT.WON) {
          thunkApi.dispatch(setWinStreakCount())
          thunkApi.dispatch(setLoseStreakCount({ reset: 0 }))
          thunkApi.dispatch(setStrategyWinCount())
          thunkApi.dispatch(setStrategyBetCount())
        } else {
          thunkApi.dispatch(setLoseStreakCount())
          thunkApi.dispatch(setWinStreakCount({ reset: 0 }))
          thunkApi.dispatch(setStrategyLoseCount())
          thunkApi.dispatch(setStrategyBetCount())
        }
      }

      if (res?.result === BET_RESULT.WON) {
        thunkApi.dispatch(setDiceWinsCount())
        thunkApi.dispatch(setDiceProfit(res))
        thunkApi.dispatch(setDiceWagered(res?.betAmount))
      } else {
        thunkApi.dispatch(setDiceLossCount())
        thunkApi.dispatch(setDiceProfit(res))
        thunkApi.dispatch(setDiceWagered(res?.betAmount))
      }

      return res
    } catch (error) {
      console.log(error)
      setBetLock(false)
      openErrorToaster(error[0].description)
      handleCancelAutoBet()
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)
